import { useNavigate } from "react-router-dom";

const SmallBanner = () => {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 w-full ">
      <div className="grid grid-cols-1 lg:grid-rows-2">
        <div className="bg-[#EDEDED] overflow-hidden flex flex-col lg:flex-row gap-4 px-2 pt-2">
          {/* Text */}
          <div className="flex flex-1 flex-col justify-center items-center lg:order-last">
            <span className="text-center text-black text-sm lg:text-lg font-semibold">
              Bốn màu tuyệt đẹp.
            </span>
            <span className="text-center text-black text-sm lg:text-lg font-semibold">
              Hai kích cỡ hoàn hảo.
            </span>
            <span className="text-center text-black text-sm lg:text-lg font-semibold">
              Một thiết kế nhôm bền chắc.
            </span>
          </div>
          {/* Image */}
          <img
            src="https://res.cloudinary.com/dyxwbtohw/image/upload/v1789379558/colors_endframe__czfie0zmty4i_medium_2x_1_djerpz.png"
            className="w-[60%] h-auto self-center lg:self-end"
            alt="ImageIPhoneAir"
          />
        </div>
        <div className="grid grid-cols-2">
          <div className="relative flex h-full w-full flex-col overflow-hidden bg-[#1D1D1F] p-2 lg:p-4 items-center justify-center">
            <img
              src="https://res.cloudinary.com/dyxwbtohw/image/upload/v1789377368/chip_endframe__lhkymtfv1uie_small_2x_xgwrtg.jpg"
              className="min-h-0 w-full flex-1 rounded-xl object-cover"
              alt="AppleVisionPro"
            />
            <div className="mt-2 flex w-full justify-center">
              <span className="text-center text-xs lg:text-base text-[#fff] font-semibold lg:font-bold">
                CPU 6 lõi, nhanh hơn đến 50%
              </span>
            </div>
          </div>
          <div className="relative flex h-full w-full flex-col overflow-hidden bg-[#2C2C2C] p-2 lg:p-4 items-center justify-center">
            {/* Text phía trên */}
            <div className="mb-2 flex w-full justify-center">
              <span className="text-center text-xs lg:text-base text-[#fff] font-semibold lg:font-bold">
                Camera 48MP Fusion Main với khẩu độ thay đổi và các điều khiển
                Pro
              </span>
            </div>

            {/* Ảnh phía dưới */}
            <img
              src="https://res.cloudinary.com/dyxwbtohw/image/upload/v1789377200/main_camera_endframe__fcjfhs06rdme_medium_2x_wrk82a.jpg"
              className="min-h-0 w-full flex-1 rounded-xl object-cover"
              alt="AppleVisionPro"
            />
          </div>
        </div>
      </div>
      <div className="bg-black flex flex-col lg:flex-row items-center relative overflow-hidden gap-2">
        <div className="flex items-center h-full lg:order-last py-4 lg:py-0">
          <img
            src={
              "https://res.cloudinary.com/dyxwbtohw/image/upload/v1789380085/3d_viewer__hgotqf9hvvee_medium_2x_1_oq0fym.png"
            }
            className="lg:h-[28rem] h-[12rem] w-auto object-contain"
            alt="iPhone18ProMax"
          />
        </div>
        <div className="lg:ml-12 flex flex-col gap-3 w-[22rem] items-center lg:items-start">
          <div className="flex flex-row lg:flex-col gap-2 justify-center">
            <span className="text-center lg:text-left text-white text-4xl lg:text-6xl">
              iPhone 18
            </span>
            <span className="text-center lg:text-left text-white text-4xl lg:text-6xl font-bold">
              Pro
            </span>
          </div>
          <span className="text-center lg:text-left text-[#909090] text-sm lg:text-base">
            Được thiết kế chuyên biệt cho hiệu năng vô đối. Thời lượng pin dài
            hơn, sạc nhanh hơn, chip A20 Pro mạnh mẽ, hệ thống tản nhiệt tiên
            tiến và camera 48MP Fusion Main hoàn toàn mới. Tất cả trong một
            thiết kế nguyên khối bền bỉ dành cho dân pro.
          </span>
          <button
            onClick={() => navigate(`/products/iPhone/iphone-18-pro`)}
            className="mb-4 px-6 py-3 border border-white rounded-md text-white hover:bg-white hover:text-black transition w-40"
          >
            Mua ngay
          </button>
        </div>
      </div>
    </div>
  );
};
export default SmallBanner;
